import { useState } from "react";
import { PageHeader, Tabs } from "@/components/Kit";
import ClassesTab from "./academics/ClassesTab";
import SubjectsTab from "./academics/SubjectsTab";
import TimetableTab from "./academics/TimetableTab";
import { Layers, BookMarked, CalendarRange } from "lucide-react";

export default function Academics() {
  const [tab, setTab] = useState("classes");
  return (
    <div data-testid="academics-page">
      <PageHeader title="Academic Management" subtitle="Classes & sections, subjects and weekly timetable" />
      <Tabs testid="acad-tabs" active={tab} onChange={setTab} tabs={[{ key: "classes", label: "Classes & Sections", icon: Layers }, { key: "subjects", label: "Subjects", icon: BookMarked }, { key: "timetable", label: "Timetable", icon: CalendarRange }]} />
      {tab === "classes" && <ClassesTab />}
      {tab === "subjects" && <SubjectsTab />}
      {tab === "timetable" && <TimetableTab />}
    </div>
  );
}
